// app/javascript/controllers/dae20/slim_search_controller.js
// SlimSelect с async AJAX-поиском для фильтровых полей (display_type: 'select')
// Использование:
//   <select data-controller="dae20--slim-search"
//           data-dae20--slim-search-url-value="/dae20/autocomplete/sources/...?attr=name">
//     <option value=""></option>
//   </select>
import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

export default class extends Controller {
  static values = {
    url: String,
    minLength: { type: Number, default: 1 }
  }

  connect() {
    this._slim = new SlimSelect({
      select: this.element,
      settings: {
        searchText: 'Нет результатов',
        searchPlaceholder: 'Начните вводить...',
        placeholderText: 'Начните вводить...',
        allowDeselect: true,
        closeOnSelect: true,
        showSearch: true,
      },
      events: {
        search: (searchValue, _currentData) => {
          return new Promise((resolve, reject) => {
            if (!searchValue || searchValue.length < this.minLengthValue) {
              resolve([])
              return
            }
            const sep = this.urlValue.includes('?') ? '&' : '?'
            fetch(`${this.urlValue}${sep}q=${encodeURIComponent(searchValue)}`, {
              headers: { Accept: 'application/json' }
            })
              .then(r => r.json())
              .then(data => {
                resolve((data.items || []).map(item => ({
                  text: String(item.label),
                  value: String(item.label)
                })))
              })
              .catch(() => reject('Ошибка загрузки'))
          })
        }
      }
    })

    // Восстанавливаем значение по умолчанию если есть
    const defaultValue = this.element.dataset.defaultValue
    if (defaultValue) {
      // Добавляем опцию с этим значением и выбираем её
      this._slim.setData([{ text: defaultValue, value: defaultValue, selected: true }])
    }
  }

  disconnect() {
    this._slim?.destroy()
  }
}
